import { observer } from '@formily/react';
import { IAnyObject } from '@yimoka/shared';
import { IStore, IStoreConfig, IStoreKey, Entity as StoreEntity } from '@yimoka/store';
import React, { useEffect } from 'react';

import { useInitStore } from '../../hooks/store';
import { StoreDict } from '../store/dict';
import { StoreRoute } from '../store/route';

import { EntitySchema, EntitySchemaProps } from './schema';

export const Entity = observer((props: IEntityProps) => {
  const { store, onStore, entity, instanceKey, dispose, ...args } = props;
  const curStore = useInitStore(store);

  useEffect(() => {
    onStore?.(curStore);
  }, [curStore, onStore]);

  return (
    <>
      <EntitySchema {...args} store={curStore} />
      <StoreDict store={curStore} />
      <StoreRoute store={curStore} />
    </>
  );
});

export interface IEntityProps<
  V extends object = IAnyObject,
  R extends object = IAnyObject,
  B extends object = IAnyObject,
> extends Omit<EntitySchemaProps<V, R, B>, 'store'> {
  store: IStore<V, R> | IStoreConfig<V, R>;
  onStore?: (store: IStore<V, R>) => void;
  entity?: StoreEntity<V>;
  instanceKey?: IStoreKey;
  /** 组件卸载时是否销毁 entity 池中的实例，默认 false */
  dispose?: boolean;
}
